<template>
  <v-card dark>
    <v-row class="pl-3">
      <v-col>
        <v-card dark elevation="12" class="d-inline-block">
          <v-img
            src="https://cdn.discordapp.com/attachments/666228815785230359/758353848292868126/infinite_hp_pot_color.png"
          ></v-img>
        </v-card>
      </v-col>
      <v-col>
        <v-card dark elevation="12" class="d-inline-block">
          <v-img
            src="https://cdn.discordapp.com/attachments/666228815785230359/758380018643632128/infinite_mp_pot_color.png"
          ></v-img>
        </v-card>
      </v-col>
      <v-col>
        <v-card dark elevation="12" class="d-inline-block">
          <v-img
            src="https://cdn.discordapp.com/attachments/666228815785230359/758380015867396126/archaelogist_map_color.png"
          ></v-img>
        </v-card>
      </v-col>
      <v-col>
        <v-card dark elevation="12" class="d-inline-block">
          <v-img
            class="grayscale"
            src="https://cdn.discordapp.com/attachments/666228815785230359/758380013270859786/lafi_compass_color.png"
          ></v-img>
        </v-card>
      </v-col>
      <v-col>
        <v-card dark elevation="12" class="d-inline-block">
          <v-img
            class="grayscale"
            src="https://cdn.discordapp.com/attachments/666228815785230359/758380021173190656/merchant_ring_color.png"
          ></v-img>
        </v-card>
      </v-col>
      <v-col>
        <v-card dark elevation="12" class="d-inline-block">
          <v-img
            src="https://cdn.discordapp.com/attachments/666228815785230359/764084937862676480/00059321.png"
          ></v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "CollectionComponent"
};
</script>

<style scoped>
.grayscale {
  filter: grayscale(1);
  -webkit-filter: grayscale(1);
}
</style>